module.exports = __webpack_public_path__ + "img/signature_docsign.65ba42ea.png";